import { usePermissionsForUser } from "./permissions";

export function useCanUseV2() {
  // isPending (no isLoading): en TanStack Query v5, isLoading = isPending &&
  // isFetching, así que puede caer en `false` en un instante intermedio
  // ANTES de que llegue el primer resultado real (isFetching momentáneamente
  // en false). El kill-switch de Dashboard.jsx usa este isLoading para no
  // actuar mientras no haya respuesta todavía -- con la semántica vieja
  // terminaba disparando `setVersion("v1")` en base a un canUseV2=false
  // transitorio, antes de que el permiso real (true) llegara.
  const { data = [], isPending } = usePermissionsForUser();
  return { canUseV2: data.includes("app:use_v2"), isLoading: isPending };
}
